<div class="message-container">
    <div class="message">
        <div class="response">
            <h3></h3>
        </div>
    </div>
</div>
